import { render, staticRenderFns } from "./MedicalCertificate.vue?vue&type=template&id=be7d9908&scoped=true"
import script from "./MedicalCertificate.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7d9908",
  null
  
)

export default component.exports